import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ userRole, allowedRoles, children }) {
  if (!userRole) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedRoute;
